import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { AGB } from './pages/AGB';
import { PmaaS } from './pages/PmaaS';
import { Schulung } from './pages/Schulung';
import { useSEO } from './hooks/useSEO';
const SEO_CONFIG: Record<string, Parameters<typeof useSEO>[0]> = {
  '#/': {
    title: 'ellnerconsultancy – Projektmanagement Excellence',
    description: 'Professionelles Projektmanagement für Mittelstand und Großunternehmen. Beratung, Schulungen und PMaaS-Pakete von erfahrenen Senior-Beratern.',
    keywords: 'Projektmanagement, Beratung, PMaaS, Schulung, Frankfurt, Mittelstand, IT-Projekte, PMP, Prince2',
    ogTitle: 'ellnerconsultancy – Projektmanagement Excellence',
    ogDescription: 'Professionelles Projektmanagement für Mittelstand und Großunternehmen. Beratung, Schulungen und PMaaS-Pakete.'
  },
  '#/pmaas': {
    title: 'Projektmanagement as a Service – ellnerconsultancy',
    description: 'Flexible PMaaS-Pakete von Small bis Individuell. Professionelles Projektmanagement zum monatlichen Festpreis – planbar, skalierbar, messbar.',
    keywords: 'PMaaS, Projektmanagement as a Service, Projektmanagement Pakete, Festpreis, Projektleiter',
    ogTitle: 'Projektmanagement as a Service – ellnerconsultancy',
    ogDescription: 'Flexible PMaaS-Pakete zum monatlichen Festpreis. Professionelles Projektmanagement für Ihr Unternehmen.'
  },
  '#/schulung': {
    title: 'Projektmanagement Schulung – Der Praxiskurs | ellnerconsultancy',
    description: 'Intensiver Tagesworkshop: Projektmanagement-Methoden, Planung, Stakeholder, Risiken und Projektabschluss. Remote oder vor Ort. Ab 490€ + MwSt.',
    keywords: 'Projektmanagement Schulung, PM Kurs, Projektmanagement Workshop, Weiterbildung, Projektplanung, agil, klassisch',
    ogTitle: 'Projektmanagement Schulung – Der Praxiskurs',
    ogDescription: 'Intensiver Tagesworkshop zu Projektmanagement-Methoden. Remote oder vor Ort. Ab 490€ + MwSt.'
  },
  '#/impressum': {
    title: 'Impressum – ellnerconsultancy',
    description: 'Impressum der ellnerconsultancy.',
    noindex: true
  },
  '#/datenschutz': {
    title: 'Datenschutzerklärung – ellnerconsultancy',
    description: 'Datenschutzerklärung der ellnerconsultancy.',
    noindex: true
  },
  '#/agb': {
    title: 'AGB – ellnerconsultancy',
    description: 'Allgemeine Geschäftsbedingungen der ellnerconsultancy.',
    noindex: true
  }
};
function SEOManager({
  path
}: {
  path: string;
}) {
  const config = SEO_CONFIG[path] || SEO_CONFIG['#/'];
  useSEO(config);
  return null;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
      window.scrollTo(0, 0);
    };
    // Set initial hash if empty
    if (!window.location.hash) {
      window.location.hash = '#/';
    }
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Simple router based on hash
  const renderPage = () => {
    // Normalize path to handle trailing slashes or query params if needed
    const path = currentPath.split('?')[0];
    switch (path) {
      case '#/impressum':
        return <Impressum data-id="element-0" />;
      case '#/datenschutz':
        return <Datenschutz data-id="element-1" />;
      case '#/agb':
        return <AGB data-id="element-2" />;
      case '#/pmaas':
        return <PmaaS data-id="element-3" />;
      case '#/schulung':
        return <Schulung data-id="element-4" />;
      case '#/':
      case '':
      default:
        return <LandingPage data-id="element-5" />;
    }
  };
  const normalizedPath = currentPath.split('?')[0] || '#/';
  return <>
      <SEOManager path={normalizedPath} data-id="element-6" />
      {renderPage()}
    </>;
}